import CommonNaviBar from '../../common/component/NaviBar'

class NaviBar extends CommonNaviBar {
  constructor (props) {
    super(props)
    this.userRole = 'admin'
    this.userRoleUrl = 'admin'
    this.naviSetting = [
      {
        dropdownToggle: 'マイページ',
        dropdownMenu: [
          {
            title: 'Home',
            url: '/admin'
          }
        ]
      },
      {
        dropdownToggle: '日常業務',
        dropdownMenu: [
          {
            title: '企業情報管理',
            url: '/admin/company'
          },
          {
            title: '都道府県別ログイン集計',
            url: '/admin/prefecture_total'
          },
          {
            title: 'お知らせ管理',
            url: '/admin/information'
          },
          {
            title: '共有ファィル管理',
            url: '/admin/shared_files'
          }
        ]
      },
      {
        dropdownToggle: 'システム設定',
        dropdownMenu: [
          {
            title: '初期値設定',
            url: '/admin/default_setting'
          },
          {
            title: '事務局管理者設定',
            url: '/admin/admin_user'
          }
        ]
      },
      {
        dropdownToggle: '個人設定',
        dropdownMenu: [
          {
            title: 'パスワード変更',
            url: '/admin/password_change'
          },
          {
            title: 'メールアドレス変更',
            url: '/admin/email_change'
          },
          {
            title: '通知受信可否設定変更',
            url: '/admin/notification_setting_change'
          }
        ]
      },
      {
        dropdownToggle: 'アンケート',
        dropdownMenu: [
          {
            title: 'アンケート設定',
            url: '/admin/survey_setting'
          },
          {
            title: 'アンケート設問設定',
            url: '/admin/survey_bigquestion'
          },
        ]
      },
    ]
  }
}

export default NaviBar



// WEBPACK FOOTER //
// ./src/admin/components/NaviBar.js